// benhurEstimateTotals
//
// returns nested collection content with totals
// for activities suitable for combined estimate
// and summaries.

const benhurEstimateTotals = values => {
  const result = {};
  values.forEach(item => {
    const {
      laborCodes = {}
    } = item;
    Object.keys(laborCodes).forEach(laborIdentifier => {
      const laborValue = laborCodes[laborIdentifier];
      const {
        title: laborTitle,
        _created: laborCreated,
        activities = {}
      } = laborValue;
      Object.keys(activities).forEach(activityIdentifier => {
        const activityValue = activities[activityIdentifier];
        const {
          title: activityTitle,
          _created: activityCreated,
          laborHours = 0,
          units = 0,
          unitsType = {}
        } = activityValue;
        const [unitsTypeIdentifier] = Object.keys(unitsType);
        if (result[laborIdentifier] === undefined) {
          result[laborIdentifier] = {
            title: laborTitle,
            _created: laborCreated,
            children: {}
          };
        }
        if (result[laborIdentifier].children[activityIdentifier] === undefined) {
          result[laborIdentifier].children[activityIdentifier] = {
            title: activityTitle,
            _created: activityCreated,
            laborHours: 0,
            units: 0,
            unitsTypes: {}
          };
        }
        const resultItem = result[laborIdentifier].children[activityIdentifier];
        resultItem.laborHours += laborHours;
        resultItem.units += units;
        if (unitsTypeIdentifier !== undefined) {
          resultItem.unitsTypes[unitsTypeIdentifier] = unitsType[unitsTypeIdentifier];
        }
      });
    });
  });
  return result;
};
module.exports = {
  benhurEstimateTotals
};